import { getEngine } from '../engine/engine';
import { reloadOpenDocuments } from './session';
import { useAppStore } from './store';

const engine = getEngine();
let installed = false;

/**
 * Connects engine callbacks to the store. Lives outside React because the engine
 * is a long-lived singleton: wiring it from a component would mean mutating that
 * singleton during an effect.
 */
export function installEngineBridge(): void {
  if (installed) return;
  installed = true;

  engine.callbacks.onMetaRestore = (docId, meta) => {
    useAppStore.getState().replaceDocument(docId, () => meta);
  };

  engine.callbacks.onContextLost = () => {
    const store = useAppStore.getState();
    store.setContextLost(true);
    store.setStatus('Graphics context lost, restoring…');
  };

  engine.callbacks.onContextRestored = () => {
    const store = useAppStore.getState();
    if (!engine.reinitialize()) {
      store.setFatalError(
        'The browser dropped the graphics context and could not create a new one. Reload the page.',
      );
      return;
    }
    void reloadOpenDocuments()
      .then(() => {
        store.setContextLost(false);
        store.setStatus('Session restored from autosave');
      })
      .catch(() => {
        store.setFatalError('Failed to restore documents after the context was reset.');
      });
  };
}
